//components
import { CountUp } from '../CountUp';

//styles
import {
  Wrap,
  ScaleLabel,
  ScaleRow,
  Stat,
  StatValue,
  StatUnit,
  StatLabel,
} from './PlatformScale.styles';

export const platformScaleStats = [
  { value: 1800, label: 'global customers' },
  { value: 4500, label: 'warehouses on the network' },
  { value: 230000, label: 'vetted carriers' },
  { value: 14, unit: 'M+', label: 'dock appointments a year' },
];

export function PlatformScale({ stats }) {
  return (
    <Wrap>
      <ScaleLabel>Platform scale &middot; today</ScaleLabel>
      <ScaleRow>
        {stats.map((stat) => (
          <Stat key={stat.label}>
            <StatValue>
              <CountUp value={stat.value} />
              {stat.unit && <StatUnit>{stat.unit}</StatUnit>}
            </StatValue>
            <StatLabel>{stat.label}</StatLabel>
          </Stat>
        ))}
      </ScaleRow>
    </Wrap>
  );
}
